export const formatCommerceType = (commerce_type?: TCommerceCategory[]): TCommerceCategory => {
  if (!commerce_type)
    return "commerce_free_media";

  if (commerce_type.length > 1)
    return commerce_type.sort((a, b) => a.length - b.length).join("|") as TCommerceCategory;

  return commerce_type[0] as TCommerceCategory;
};
